export const formatPrice = (p) => {
  if (p.price_amount == null) return p.price_display || "Pricing pending";
  const amt = `$${Number(p.price_amount).toLocaleString()}`;
  return p.billing_interval ? `${amt} ${p.billing_interval}` : amt;
};

export const feeBadge = (p) =>
  p.fee_type === "one_time" ? "One-time fee" : "Recurring";

export const AVAILABILITY = {
  available: { label: "Available", cls: "bg-[#84CC16]/20 text-[#84CC16]" },
  limited: { label: "Limited", cls: "bg-amber-500/20 text-amber-400" },
  sold_out: { label: "Sold out", cls: "bg-red-500/20 text-red-400" },
  coming_soon: { label: "Coming soon", cls: "bg-slate-700 text-slate-300" },
};
